/* eslint-disable max-lines */
/* eslint-disable complexity */
/* eslint-disable max-statements */
import { FormId } from "../../../../../../../constant/FormId"
import { UseSchedulesExportFileProps } from "../../../../models/list"
import { exportFRMDefault } from "./exportDefault"
import { exportFRM101 } from "./exportFRM101"
import { exportFRM102 } from "./exportFRM102"
import { exportFRM103 } from "./exportFRM103"
import { exportFRM301 } from "./exportFRM301"
import { exportFRM302 } from "./exportFRM302"
import { Translate } from "../../../../../../../constant/Translate"
import { scheduleApi } from "../../../../apis"
import { AxiosErrorType } from "../../../../../../../infrastructure/axiosError/models"
import { pushStateError } from "../../../../../../../utils/pushStateError"
import { Routers } from "../../../../../../../constant/Routers"
import { convertDataSearch } from "./convertDataSearch"
import { Variables } from "../../../../constants/list/variables"
import { useVariablesExportFile } from "../useVariablesExportFile"

const { DEFAULT, FRM101, FRM102, FRM103, FRM301, FRM302 } = FormId
const { SCR973 } = Routers
const {
  MESSAGE_C0033,
  MESSAGE_C0034,
  MESSAGE_C0035,
  MESSAGE_C0036,
  MESSAGE_C0044,
  MESSAGE_C0045,
  MESSAGE_C0046,
  MESSAGE_C0047,
  MESSAGE_C0056,
  MESSAGE_C0057,
  MESSAGE_C0058,
  MESSAGE_C0059,
} = Translate
const { EXPORT_FRM103_OVER_RECORD } = Variables

export const useExportFile = ({
  dataSource,
  form,
  selectedRowKeys,
  setIsLoadingTable,
}: UseSchedulesExportFileProps) => {
  const {
    dataSourceFrm103,
    formId,
    isOpenExportFrm103OverRecord,
    isOpenModalExport,
    messageConfirmDownload,
    onCancelExportFrm103OverRecord,
    onOpenExportFrm103OverRecord,
    pathname,
    push,
    setDataSourceFrm103,
    setFormId,
    setIsOpenModalExport,
    setMessageConfirmDownload,
  } = useVariablesExportFile()

  const handleCancelModalExport = () => {
    setIsOpenModalExport(false)
  }

  const handleOpenModalExport = (_formId: string) => {
    const getMessage = (msg1: string, msg2: string) =>
      selectedRowKeys?.length ? msg1 : msg2
    if (_formId === DEFAULT) {
      const msg = getMessage(MESSAGE_C0033, MESSAGE_C0034)
      setMessageConfirmDownload(msg)
    }
    if (_formId === FRM101) {
      const msg = getMessage(MESSAGE_C0044, MESSAGE_C0045)
      setMessageConfirmDownload(msg)
    }
    if (_formId === FRM102) {
      const msg = getMessage(MESSAGE_C0046, MESSAGE_C0047)
      setMessageConfirmDownload(msg)
    }
    if (_formId === FRM301) {
      const msg = getMessage(MESSAGE_C0035, MESSAGE_C0036)
      setMessageConfirmDownload(msg)
    }
    if (_formId === FRM302) {
      const msg = getMessage(MESSAGE_C0058, MESSAGE_C0059)
      setMessageConfirmDownload(msg)
    }
    if (_formId === FRM103) {
      const msg = getMessage(MESSAGE_C0056, MESSAGE_C0057)
      setMessageConfirmDownload(msg)
    }

    setIsOpenModalExport(true)
    setFormId(_formId)
  }

  const handleExportFile = () => {
    try {
      const _dataSource = selectedRowKeys?.length
        ? dataSource.filter((item) =>
            selectedRowKeys.includes(item.info.travelScheduleId),
          )
        : dataSource

      if (formId === DEFAULT) exportFRMDefault(_dataSource, pathname)

      if (formId === FRM101) exportFRM101(_dataSource)

      if (formId === FRM102) exportFRM102(_dataSource)

      if (formId === FRM103) {
        if (form) {
          const data = convertDataSearch(form.getFieldsValue())
          setIsLoadingTable(true)
          scheduleApi
            .getExportFRM103(data)
            .then((res) => {
              if (res.length > EXPORT_FRM103_OVER_RECORD) {
                onOpenExportFrm103OverRecord()
                setDataSourceFrm103(res)
              } else {
                exportFRM103(res)
              }
            })
            .catch((error: AxiosErrorType) => {
              // 「SCR973_エラー情報の表示画面」に遷移する。
              const stateError = pushStateError(error)
              push({ pathname: SCR973, state: stateError })
            })
            .finally(() => {
              setIsLoadingTable(false)
            })
        }
      }

      if (formId === FRM301) exportFRM301(_dataSource)

      if (formId === FRM302) exportFRM302(_dataSource)
    } finally {
      handleCancelModalExport()
    }
  }

  const onOkExportFrm103OverRecord = () => {
    setIsLoadingTable(true)
    setTimeout(() => {
      try {
        exportFRM103(dataSourceFrm103)
      } finally {
        setIsLoadingTable(false)
      }
    }, 0)
  }

  return {
    handleCancelModalExport,
    handleExportFile,
    handleOpenModalExport,
    isOpenExportFrm103OverRecord,
    isOpenModalExport,
    messageConfirmDownload,
    onCancelExportFrm103OverRecord,
    onOkExportFrm103OverRecord,
    push,
  }
}
